import { render, staticRenderFns } from "./gettheapp.vue?vue&type=template&id=7c7fa70e&scoped=true&"
var script = {}
import style0 from "./gettheapp.vue?vue&type=style&index=0&id=7c7fa70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7fa70e",
  null
  
)

export default component.exports